module.exports = __webpack_public_path__ + "static/media/5.96be078e.png";